import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  currentFiltersSelector,
  SBAT_GROUP_FILTERS,
  setFilterValue,
} from 'features/classCreation';
import { FILTER_TYPE } from 'data/filterType';
import Field from 'components/Field';
import SbatGroupSuperBatchSelect from '../SbatGroupsSuperBatchSelect';

function SuperBatchesFilter({ sbatGroups }) {
  const dispatch = useDispatch();
  const { superBatches } = useSelector(currentFiltersSelector);

  const handleOnChange = useCallback(
    (option) => {
      dispatch(
        setFilterValue({
          key: SBAT_GROUP_FILTERS.superBatches,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <Field
      label="Batches"
      labelClassName="h5"
    >
      <SbatGroupSuperBatchSelect
        sbatGroups={sbatGroups}
        placeholder="Select from dropdown"
        value={superBatches}
        onChange={handleOnChange}
      />
    </Field>
  );
}

export default SuperBatchesFilter;
